import { configureStore } from "@reduxjs/toolkit";
import hirinManagerSlice from "./hiringManagerSlice";
import jobSlice from "./jobSlice";
import companyProfileSlice from "./companyProfileSlice";

const store = configureStore({
  reducer: {
    hiringManager: hirinManagerSlice,
    companyJob: jobSlice,
    company: companyProfileSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
